import CustomCircularProgress from './CustomCircularProgress';

export default CustomCircularProgress;
